import { render } from "./Dashboard5.vue?vue&type=template&id=29337fc9&scoped=true"
import script from "./Dashboard5.vue?vue&type=script&lang=js"
export * from "./Dashboard5.vue?vue&type=script&lang=js"

import "./Dashboard5.vue?vue&type=style&index=0&id=29337fc9&lang=css"
import "./Dashboard5.vue?vue&type=style&index=1&id=29337fc9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29337fc9"]])

export default __exports__